import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Session from "supertokens-auth-react/recipe/session";
import { useHookstate } from "@hookstate/core";
import { globalUserState } from "../globalState";

const ProfileDropdown = () => {
  const userState = useHookstate(globalUserState);
  const user = userState.get(); // Get the current user object from global state

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.log("Frontend: Attempting to sign out...");
    try {
      await Session.signOut();
      console.log("Frontend: Session.signOut() successful.");
      userState.set({}); // Clear user state on logout
      navigate("/auth"); // Adjust route if your login is at another path
    } catch (error) {
      console.error("Frontend: Error during Session.signOut():", error);
      alert("Logout failed. Please try again.");
    }
  };

  return (
    
    <div className="relative flex items-center space-x-4">
      {/* Profile Dropdown Button */}
      <button
        className="flex items-center space-x-2 focus:outline-none"
        onClick={() => setDropdownOpen((open) => !open)}
      >
        {/* Avatar (replace src with real profile pic if available) */}
        {/* {console.log("ProfileDropdown user:", user)} */}
        <img
          src={"https://ui-avatars.com/api/?name=" + (user.fullName || "User")}
          alt="profile"
          className="w-8 h-8 rounded-full border-2 border-blue-200"
        />
        <span className="font-medium text-gray-200">
          {user.fullName || "User"}
        </span>
        <svg className="w-4 h-4 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M19 9l-7 7-7-7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {/* Dropdown Menu */}
      {dropdownOpen && (
        <div
          className="absolute right-0 mt-12 w-44 bg-white shadow-lg rounded-xl py-2 z-50 animate-fade-in"
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <Link
            to="/profile"
            className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            onClick={() => setDropdownOpen(false)}
          >
            Profile
          </Link>
          <Link
            to="/settings"
            className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
            onClick={() => setDropdownOpen(false)}
          >
            Settings
          </Link>
          <button
            onClick={handleLogout}
            className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
